import React, { useEffect, useState } from 'react';
import { useSites } from '../../../contexts/SitesContext';
import Input from '../../../shared/forms/Input';
import Modal, { ModalCloseButton } from '../../../shared/modals/Modal';
import TooltipTrigger from '../../../shared/components/TooltipTrigger';
import { ReactComponent as TriangleIcon } from '../../../assets/icons/triangle.svg';

const DeleteSiteModal = ({setDeleteSiteModalVisible, site}) => {
  const { deleteSite } = useSites();
  const [answer, setAnswer] = useState('');
  const [showConfirmationAttention, setShowConfirmationAttention] = useState(false);
  const [hasTriedSubmit, setHasTriedSubmit] = useState(false);
  const isConfirmed = answer.trim() === 'YES';
  const confirmationMessage = answer.trim() === ''
    ? (hasTriedSubmit ? 'Type YES in all caps to continue.' : null)
    : (isConfirmed ? null : 'Please type YES in all caps exactly as shown.');

  useEffect(() => {
    if (!showConfirmationAttention) return undefined;

    const timeoutId = window.setTimeout(() => {
      setShowConfirmationAttention(false);
    }, 900);

    return () => window.clearTimeout(timeoutId);
  }, [showConfirmationAttention]);

  const triggerConfirmationAttention = () => {
    setShowConfirmationAttention(false);
    window.requestAnimationFrame(() => {
      setShowConfirmationAttention(true);
    });
  };

  const closeModal = () => setDeleteSiteModalVisible(false);

  return (
    <Modal isOpen={true} onClose={closeModal} className="modal--medium modal--full-height">
      <div className='modal'>
        <div className='modal__header'>
          <h3 className='margin-none'>Delete Website</h3>
          <ModalCloseButton
            onClick={closeModal}
            label="Close delete website modal"
          />
        </div>

        <div className="modal__body">
          <form
            id="delete-site-form"
            onSubmit={(e) => {
              e.preventDefault();
              setHasTriedSubmit(true);
              if (!isConfirmed) {
                triggerConfirmationAttention();
                return;
              }
              closeModal();
              deleteSite(site);
            }}
          >
            <h4 className="margin-none padding-b">
              Are you sure you want to delete <strong>{site.website}</strong>?
            </h4>
            <p className="margin-none">
              Please type <strong>YES</strong> below to confirm deletion.
            </p>
            <p className="simple-row margin-none">
              <TriangleIcon
                className="icon sm"
                style={{ fill: 'var(--warning)', flex: '0 0 auto', marginTop: '0.1rem' }}
              />
              <span>
                This permanently removes the website and all related data.
              </span>
            </p>
            <div className="field-stack">
                <Input
                  label="Confirmation"
                  placeholder="YES"
                  value={answer}
                  onChange={(e) => {
                    setAnswer(e.target.value);
                  }}
                  className={showConfirmationAttention ? 'is-attention' : ''}
                  icon={<TooltipTrigger text="Type YES in all caps exactly as shown." />}
                />
                {confirmationMessage && (
                  <p className="field-message">
                    {confirmationMessage}
                  </p>
                )}
              </div>
          </form>
        </div>

        <div className='modal__footer'>
          <button
            type="button"
            className="btn secondary"
            onClick={closeModal}
          >
            Cancel
          </button>
          <button
            type="submit"
            form="delete-site-form"
            className={'btn destructive' + (isConfirmed ? '' : ' disabled')}
            aria-disabled={!isConfirmed}
            onClick={() => {
              if (!isConfirmed) {
                setHasTriedSubmit(true);
                triggerConfirmationAttention();
              }
            }}
          >
            Delete Website
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default DeleteSiteModal;
